import { Component, OnInit } from '@angular/core';
import { WebStorageService } from '../services/web-storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-unauthorized',
  templateUrl: './page-unauthorized.component.html',
  styleUrls: ['./page-unauthorized.component.sass'],
  standalone: false
})
export class PageUnauthorizedComponent {

  constructor(private router: Router) {
  }

  gotoHome() {
    this.router.navigate(['/']);
  }

}
